import React, { useState,useRef,useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import Timeline from "react-calendar-timeline";
import "react-calendar-timeline/lib/Timeline.css";
import Header from "../../../Layout/User/Header";
import { FaCar, FaParking, FaPlus } from "react-icons/fa";
import CustomTimeline from "../../../Components/CustomeTimeline/CustomeTimeline";
import "../../pages.css";
import moment from "moment";
import TimelineScheduler from "../../../Components/TimeS";
import CustomScrollbar from "../../../Components/CustomScrollbar/CustomScrollbar";
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css"; 
import { enGB, srLatn } from "date-fns/locale";
import { format } from "date-fns";
import RegularModal from "../../../Components/Modals/RegularReservationModal";
import EditModal from "../../../Components/Modals/EditReservationModal";

import withAuth from "../../../Components/CheckSessionStorage/sessionUtils";

import apiRequest from "../../../api";


const Parking = () => {
  const selectedLanguageRef = useRef(localStorage.getItem('Language'));
  useEffect(() => {
    // Handle changes from other tabs/windows and local changes
    const handleLanguageChange = (event) => {
      selectedLanguageRef.current = event.detail['selectedLanguage'];
    };

    window.addEventListener('languageChange', handleLanguageChange);
    return () => {
      window.removeEventListener('languageChange', handleLanguageChange);
    };
  }, []);
  const locale = selectedLanguageRef.current === 'RS' ? srLatn : enGB;
  const calendarRef = useRef(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false)
  const [selectedDate, setSelectedDate] = useState(new Date());

  const [isMainCalendarOpen, setIsMainCalendarOpen] = useState(false);
  const [baseGroups, setBaseGroups] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true); // To manage loading state
  const [error, setError] = useState(null);

  const handleSelect = (date) => {
    setSelectedDate(date);
    setIsMainCalendarOpen(false); // Close the calendar after selecting a date
    fetchReservations(date);
  };
  const [selectedRow, setSelectedRow] = useState({
    start_time: new Date(),
    end_time: new Date(),
    name: "",
    username: "",
    company: "",
    id: "",
    notes: "",
  });
  const toggleModal = (date) => {
    setModalOpen(!modalOpen);
  };
  const toggleEditModal = (row) => {
    if (editModal === true) {
      // Close modal, no need for additional action when closing
      setEditModal(false);
    } else {
      setSelectedRow({
        start_time: row.start_time,
        end_time: row.end_time,
        name: row.name,
        username: "",
        company: row.company,
        id: row.id,
        notes: row.notes,
      });
      setEditModal(true);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target) // Check if click is outside
      ) {

        setIsMainCalendarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const formatTime = (date) => {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };
  const fetchReservations = async (date = selectedDate) => {
    const formatDateToLocal = (date) => {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
      const day = date.getDate().toString().padStart(2, "0");

      return `${year}-${month}-${day}`;
    };
    try {
      // Retrieve JWT from localStorage
      const token = sessionStorage.getItem("jwt");


      const formattedDate = formatDateToLocal(date);
      console.log("Usao u fetch", date, formattedDate);
      const reservations = await apiRequest(`/api/reservations/get_all_reservations?date=${formattedDate}`, 'GET', null, token);
      console.log("FormattedData", reservations);


      const formattedData = reservations.map((reservation) => {
        const startDate = new Date(reservation.startTime);
        const endDate = new Date(reservation.endTime);
        
        return {
          id: reservation.reservationCode,
          username: reservation.username || "",
          parkingLot: reservation.parkingLot,
          start_time: startDate,
          end_time: endDate,    
          name: reservation.name || "",      
          company: reservation.company || "",
          title: `${formatTime(startDate)} - ${formatTime(endDate)}`,
          notes: reservation.notes
        };
      });
      
      setItems(formattedData);

      const lots = await apiRequest('/api/parking_lots/get_all', 'GET', null, token);
      console.log("Formattedlots",lots);
      const formattedLots = lots.map((lots) => {
        return {
          parkingLot: lots.parkingLot
        };
      });
      setBaseGroups(formattedLots);

      console.log("Items:", formattedData);
      console.log("Lots:", formattedLots);
    } catch (err) {
      setError(err.message);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Start loading
      await fetchReservations(); // Fetch data
      setLoading(false); // Stop loading
    };

    fetchData();
  }, []); // Runs only once when the component is mounted
 

  if (loading) {
    return <Header />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }
  return (
    <>
      <Header />
      <Container >
        <Row className="my-3">
          <Col xs="8" sm="6"  md="9"   className="text-start  d-flex align-items-center justify-content-start  justify-content-md-start  ">
            <div className=" form-group position-relative date_input" ref={calendarRef}>
              
              <img
                src="/assets/icons/calendarDay.svg"
                alt="Calendar Icon"
                className="calendar-icon"
              />
              <input
                type="text"
                className="form-control custom-input"
                value={format(selectedDate, "dd.MM.yyyy")} // Display the selected date
                onClick={() => setIsMainCalendarOpen((prev) => (!prev))} // Toggle calendar visibility
                readOnly
                style={{cursor:"pointer"}}
              />

              
              {isMainCalendarOpen && (
                <div className="calendar-container" >
                  <Calendar
                    date={selectedDate}
                    onChange={handleSelect}
                    locale={locale} // Set the locale
                    color="#3d91ff"
                  />
                </div>
              )}
            </div>
          </Col>
          <Col

            xs="4"
            sm="6"
            md="3"
            
            className="text-end d-flex  justify-content-end"
          >
            <div className=' text-end btn-container d-flex justify-content-end justify-content-md-end '   >
              <Button className='add-btn' onClick={toggleModal} > <div>+</div> </Button>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>

          {/* <div className="scrollbar" id="style-9"   >
          <div className="force-overflow" style={{height:200}} > */}
            <TimelineScheduler onEdit={(row) => toggleEditModal(row)} fetchReservations={() => fetchReservations()} baseGroups={baseGroups} items={items}/>
          {/* </div>
          </div> */}

          </Col>
        </Row>

       
      </Container>
      <RegularModal
        isOpen={modalOpen}
        toggle={toggleModal}
        fetchReservations={fetchReservations}
        selectedDate={selectedDate}
      />

      <EditModal
        isOpen={editModal}
        toggle={toggleEditModal}
        selectedRow={selectedRow}
        fetchReservations={fetchReservations}
      />
    </>
  );
};

export default withAuth(Parking);
